/**
 * services/api.js — thin barrel for backward compatibility.
 *
 * All endpoint definitions now live in per-domain modules:
 *   - services/authAPI.js
 *   - services/filesAPI.js
 *   - services/applicantAPI.js
 *   - services/recruiterAPI.js
 *   - services/adminAPI.js
 *   - services/screeningAPI.js
 *   - services/walletAPI.js
 *   - services/prepAPI.js   (also: journeyAPI, interviewJourneyAPI, interviewAPI)
 *   - services/staffingAPI.js (also: adminStaffingAPI, adminCandidatesAPI)
 *   - services/miscAPI.js   (notifications, tags, search, analytics, reports, jay, support, org)
 *
 * Prefer importing directly from those modules in new code. Imports from
 * `@/services/api` continue to work via the re-exports below.
 */
export { authAPI } from './authAPI';
export { filesAPI } from './filesAPI';
export { applicantAPI } from './applicantAPI';
export { recruiterAPI } from './recruiterAPI';
export { adminAPI } from './adminAPI';
export { screeningAPI, interviewAPI } from './screeningAPI';
export { walletAPI } from './walletAPI';
export { prepAPI, journeyAPI, interviewJourneyAPI } from './prepAPI';
export { staffingAPI, adminStaffingAPI, adminCandidatesAPI } from './staffingAPI';
export {
  analyticsAPI, tagsAPI, searchAPI, notificationAPI,
  supportAPI, orgAPI, reportsAPI, jayAPI,
} from './miscAPI';
export { emailPrefsAPI } from './miscAPI';

// Default export: the shared axios client (used by a few legacy callers that did `import api from '...'`).
import client from './client';
export default client;
